var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.125 70.8332L66.6666 47.2915L60.625 41.2498L43.0416 58.8748L34.2916 50.1248L28.3333 56.0415M27.0833 83.3332C20.75 83.3332 15.3472 81.1526 10.875 76.7915C6.40274 72.4026 4.16663 67.0554 4.16663 60.7498C4.16663 55.3332 5.79163 50.4998 9.04163 46.2498C12.3194 41.9998 16.5972 39.2915 21.875 38.1248C23.625 31.7359 27.0972 26.5693 32.2916 22.6248C37.5138 18.6526 43.4166 16.6665 50 16.6665C58.1388 16.6665 65.0277 19.4998 70.6666 25.1665C76.3333 30.8054 79.1666 37.6943 79.1666 45.8332C83.9722 46.3887 87.9444 48.4721 91.0833 52.0832C94.25 55.6387 95.8333 59.8054 95.8333 64.5832C95.8333 69.8054 94.0138 74.2359 90.375 77.8748C86.7361 81.5137 82.3055 83.3332 77.0833 83.3332H27.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud-icon.1f1a459c3a08798e8776dd5846300e00.svg";
export { ForwardRef as ReactComponent };